import { MouseEvent, useCallback, useRef, useState } from "react";

import ExportServiceForm, { ExportServiceFormHandle, Values } from "@/Administration/Components/Services/ExportServicePopup/ExportServiceForm/ExportServiceForm";
import { IServiceComboGridModel } from "@/Administration/Models/UI/ServiceCombo/IServiceComboGridModel";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import "./ExportServicePopup.scss";

interface ExportServiceProps {
    model: IServiceComboGridModel;
    onCancel?: () => void;
    onSubmit?: (value: Values) => void;
}

function ExportServicePopup(props: ExportServiceProps): JSX.Element {
    const { model, onCancel } = props;

    const formRef = useRef<ExportServiceFormHandle>(null);

    const { getText: t } = useTranslation();
    const [isValid, setIsValid] = useState(false);

    const handleChange = useCallback(
        () => setIsValid(formRef.current?.isValid()),
        []
    );

    const handleCancelClick = (): void => {
        onCancel?.();
    };

    const handleDownloadClick = (e: MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();

        handleCancelClick();

        formRef.current.submit();
    };

    return (
        <Modal
            cssClass="export-service-popup-title"
            width={1080}
            onClose={onCancel}
            draggable={false}
            title={t("ExportTimeSlotsLabel")}
            disableOverlayClose
            centerContent
            showOverlay
            showX
            footer={(
                <div className="flex-container flex-end">
                    <ButtonGroup>
                        <ButtonControl
                            className="btn btn-default"
                            onClick={handleCancelClick}
                            label={t("CancelLabel")}
                        />

                        <ButtonControl
                            variant="brand"
                            disabled={!isValid}
                            onClick={handleDownloadClick}
                            label={t("Cnesst_DownloadForm")}
                        />
                    </ButtonGroup>
                </div>
            )}
        >
            <ExportServiceForm
                ref={formRef}
                model={model}
                onChange={handleChange}
            />
        </Modal>
    );
}

export default ExportServicePopup;
